import { render, staticRenderFns } from "./ProjectDocumentEditFormFrProject.vue?vue&type=template&id=d0fb054e&"
import script from "./ProjectDocumentEditFormFrProject.vue?vue&type=script&lang=js&"
export * from "./ProjectDocumentEditFormFrProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports